import { Card } from "@/src/components/cards";
import { FetchableList } from "@/src/components/fetchableLists";
import {
  Billet,
  Hospitalisation,
  Patient,
  PatientDocument,
} from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";
import { openDocumentForm, openEditor } from "../documents/documentsHook";
import { getItemId, getUserId } from "@/src/utils/utils";
import { CgFileDocument } from "react-icons/cg";
import { openBillet, openHospitalisationBilletForm } from "./billet";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";

export async function openAdmissionDocumentsList({
  hospitalisation,
  patient,
  onConfirm,
}: {
  hospitalisation: Hospitalisation;
  patient: Patient | null | undefined;
  onConfirm: (hospitalisation: Hospitalisation) => void;
}) {
  await openDrawer({
    id: "bureauAdmissionsHospitalisationDrawer",
    title: "Hospitalisation",
    content: (
      <AdmissionDocumentsList
        hospitalisation={hospitalisation}
        patient={patient}
        onSelect={() => {
          closeDrawer("bureauAdmissionsHospitalisationDrawer");
        }}
        onChange={async (newValue) => {
          onConfirm(hospitalisation);
          closeDrawer("bureauAdmissionsHospitalisationDrawer");
        }}
      />
    ),
  });
}

function AdmissionDocumentsList({
  hospitalisation,
  patient,
  onChange,
  onSelect,
}: {
  hospitalisation: Hospitalisation;
  patient: Patient | null | undefined;
  onChange: (newValue: PatientDocument) => void;
  onSelect: (templateId: string) => void;
}) {
  const [reload, setReload] = useState(0);

  async function onDocumentSaved(patientDocument: PatientDocument) {
    patientDocument.creator = getUserId();

    patientDocument = await apiFetch("patientDocuments", "addOne", {
      patientDocument,
    });

    onChange(patientDocument);
  }

  async function openDocument({ templateId }: { templateId: string }) {
    let template = await apiFetch("documentTemplates", "loadOne", {
      id: templateId,
    });

    if (!template) throw new Error("Aucun template trouvé.");

    let patientDocuments = await apiFetch(
      "patientDocuments",
      "loadByParent",
      {
        parentId: hospitalisation.id,
        templateId,
      },
      "Erreur lors du chargement du document"
    );

    let patientDocument = patientDocuments?.[patientDocuments.length - 1];
    console.log("patientDocument", patientDocument);

    if (patientDocument) {
      await openEditor({
        patient,
        patientDocument,
        onSave: (newValue) => {
          patientDocument = newValue;
          onDocumentSaved(patientDocument);
          onChange(patientDocument);
        },
      });
    } else {
      patientDocument ||= {
        patient: patient,
        creator: USER?.get(),
        template: template,
        parent: getItemId(hospitalisation),
        content: template.content,
        title: template.title || "Nouveau document",
        status: "pending",
        refAnswer: {
          creator: USER?.get(),
          reference: template.reference,
          patient: patient,
          fieldAnswers: [],
          notes: "",
          conclusion: "",
        },
      };

      await openDocumentForm({
        patient,
        patientDocument,
        onChange: (newValue) => {
          patientDocument = newValue;
          onDocumentSaved(patientDocument);
          onChange(patientDocument);
        },
        onSave: (newValue) => {
          onChange(patientDocument);
        },
      });
    }
  }

  return (
    <div className="c1 gap10">
      <div className="bold">Documents d&apos;admission</div>
      <FetchableList
        queryKey={["admissionDocumentsList", reload]}
        queryFn={() =>
          apiFetch("documentTemplates", "loadMany", {
            types: ["admission"],
          })
        }
      >
        {(data) => (
          <div className="c1 mc1 gap10">
            {data?.map((template) => (
              <Card
                key={`template-${template.id}`}
                leading={<CgFileDocument size={20} color="var(--main-color)" />}
                title={template.name}
                onClick={async () => {
                  if (!template.id) return;
                  onSelect(template.id);
                  if (!patient) throw new Error("Patient non trouvé");
                  if (
                    template.name?.toLowerCase() == "billet de salle" ||
                    template.name?.toLowerCase() == "billet de sortie"
                  ) {
                    let item: Billet = {
                      type: "billet",
                      patient,
                      creator: getUserId(),
                      parent: hospitalisation,
                      functionalSigns: [],
                      physicalSigns: [],
                      readBy: [getUserId()],
                      confidentiality: getStandardConfidentiality(patient),
                    };

                    return await openBillet({
                      item,
                      title: template.name,
                      parent: hospitalisation,
                      patient,
                      onChange: (item, patientDocument) => {
                        setReload(reload + 1);
                        onChange(patientDocument);
                      },
                    });
                  }
                  await openDocument({
                    templateId: template.id,
                  });
                }}
              >
                {/* {template.name} */}
              </Card>
            ))}
          </div>
        )}
      </FetchableList>
    </div>
  );

  //     <div className="c2 mc1 gap10">
  //     <Card
  //       onClick={async () => {
  //         let allEvolutions = await apiFetch(
  //           "evolutionItems",
  //           "loadMany",
  //           {
  //             patientId: patient.id,
  //             parentId: hospitalisation.id,
  //           },
  //           "Erreur lors du chargement de l'historique"
  //         );

  //         let billet: Billet | undefined = allEvolutions?.find(
  //           (evolution) => evolution.type == "billet"
  //         );

  //         if (!billet)
  //           billet = {
  //             type: "billet",
  //             patient,
  //             creator: getUserId(),
  //             parent: hospitalisation,
  //             functionalSigns: [],
  //             physicalSigns: [],
  //             readBy: [getUserId()],
  //             confidentiality: getStandardConfidentiality(patient),
  //           };

  //         await openBillet({
  //           item: billet,
  //           parent: hospitalisation,
  //           patient,
  //           onChange: (billet) => {
  //             onConfirm(hospitalisation);
  //           },
  //         });
  //       }}
  //     >
  //       <div className="c1 center gap10">
  //         <TbBed size={20} />
  //         <div className="bold">Billet d&apos;admission</div>
  //       </div>
  //     </Card>

  //     <Card onClick={async () => {}}>
  //       <div className="c1 center gap10">
  //         <IoMdExit size={20} />
  //         <div className="bold">Billet de sortie</div>
  //       </div>
  //     </Card>
  //     <Card
  //       onClick={async () => {
  //         await openDocument({
  //           templateId: "documentTemplates:1710857751420a17lrb9l9",
  //         });
  //       }}
  //     >
  //       <div className="c1 center gap10">
  //         <TbLayoutBottombarCollapse size={20} />
  //         <div className="bold">Certificat de décès</div>
  //       </div>
  //     </Card>
  //     <Card onClick={async () => {}}>
  //       <div className="c1 center gap10">
  //         <MdOutlineNightsStay size={20} />
  //         <div className="bold">Certificat de séjour</div>
  //       </div>
  //     </Card>
  //     <Card onClick={async () => {}}>
  //       <div className="c1 center gap10">
  //         <PiVirusBold size={20} />
  //         <div className="bold">Certificat de non contagion</div>
  //       </div>
  //     </Card>
  //   </div>
}

export default AdmissionDocumentsList;
